import { CreateCustomerState } from '@store/customers';
import { DateTime } from 'luxon';

export const initialState: CreateCustomerState = {
  isLoading: true,
  isError: false,
  errorMessage: '',
  responseData: {
    id: '',
    successMessage: '',
  },
  customer: {
    atgLiability: null,
    accountManagerId: null,
    accountManagerName: null,
    accountManagerOfficeId: null,
    accountingSysBalance: null,
    accountingSysId: null,
    agentLiability: null,
    agentLiabilityEffectiveDate: null,
    agentLiabilityNote: null,
    allowAutoDispatch: false,
    alwaysTrackLoads: false,
    approvedCustomerDoNotSolicitDate: null,
    billingInstructions: null,
    businessTypeCode: null,
    businessTypeDisplayName: null,
    businessTypeId: null,
    businessTypeName: null,
    capacityGroupId: null,
    chargeCreditCardFee: null,
    claimedBy: null,
    claimedById: null,
    collectionComments: null,
    collectionTerms: 'Net 30',
    collectionTierId: null,
    collectionsUserId: null,
    comments: [],
    commissionDiscount: null,
    contacts: [],
    createdDate: DateTime.now()
      .toUTC()
      // eslint-disable-next-line prettier/prettier
      .toFormat('yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\''),
    creditInsuranceCoverageType: null,
    creditInsuranceCoverageTypeName: null,
    creditInsuranceId: null,
    creditInsurancePolicyDate: null,
    creditLimit: 0,
    customerExists: false,
    defaultLogoUrl: null,
    ediMapping: null,
    ediRequest: null,
    ediTemplateId: null,
    enableCSP: false,
    enableLTL: false,
    exceptionReason: null,
    financials: {
      id: 0,
      avgDaysToPay: null,
      avgDaysToPayOneMonth: null,
      avgDaysToPayThreeMonths: null,
      avgDaysToPaySixMonths: null,
      avgDaysToPayTwelveMonths: null,
      avgProfit: null,
      avgMargin: null,
      openBalance: null,
      balancePastDue: null,
      availableCredit: null,
      lastLoadDate: null,
      lastLoadCreatedDate: null,
      openClaimsBalance: null,
      avgProfidTotal: null,
      avgProfit1M: null,
      avgProfit3M: null,
      avgProfit6M: null,
      avgProfit12M: null,
      avgMarginTotal: null,
      avgMargin1M: null,
      avgMargin3M: null,
      avgMargin6M: null,
      avgMargin12M: null,
    },
    groups: [],
    holdRetraction: false,
    id: 0,
    insurance: null,
    insuredFor: 0,
    invoiceMethod: null,
    invoicePaperworkRequired: false,
    isApprovedCustomerDoNotSolicit: null,
    isCustomerCentralized: null,
    isPublic: true,
    keyReasonId: null,
    ltlCostPlus: null,
    loadInstructions: null,
    loadPending: false,
    mailingAddress1: null,
    mcNumber: null,
    isAuthorityFreightBroker: null,
    isAuthorityCarrier: null,
    isAuthorityFreightForwarder: null,
    isAuthorityDirectShipper: null,
    assetBased: null,
    isCrossBorder: null,
    mailingAddress2: null,
    mailingCity: null,
    mailingState: null,
    mailingZip: null,
    metadata: [],
    name: null,
    needsPreapproval: null,
    nextActionDate: null,
    optOutBalanceEmail: false,
    optOutPastDueDateBalanceEmail: false,
    orderSummary: null,
    outstandingBalance: 0,
    outstandingOrders: null,
    pcMilerVersion: null,
    parentId: null,
    password: null,
    paymentTerms: 'Net 30',
    paymentType: 0,
    pendingCreditRequests: [],
    physicalAddress1: null,
    physicalAddress2: null,
    physicalCity: null,
    physicalState: null,
    physicalZip: null,
    prospectId: null,
    quotes: [],
    requestedCustomerDoNotSolicit: null,
    requests: [],
    requiredDocumentTypes: [],
    revisitRetractionDate: null,
    salesManagerId: null,
    salesManagerName: null,
    salesManagerOfficeId: null,
    seasonality: null,
    seasonalityComment: null,
    status: 'Pending',
    taxId: null,
    trackingServiceId: null,
    trackingVisibilityProvider: null,
    trackingXId: null,
    trackings: null,
    userName: null,
    verified: false,
  },
};

export const contactModalId = 'newCustomerContactModalId';
